export default function userName (user) {
    const { alias = '', firstname = '', lastname = '', dealer = {}} = user || {}
    const firmName = dealer && dealer.firm_name || ''
    const name = !firmName && `${firstname} ${lastname}`.trim()

    return alias || firmName || name
}